// Warstwa synchronizacji, wymienna (plan 4.1): na start bez serwera ('lokalnie'), potem prywatna kopia, docelowo Supabase w UE.
// Na iPhonie nie ma synchronizacji w tle, więc próbujemy: przy otwarciu, przy powrocie do aplikacji, co 2 min gdy otwarta, i na przycisk.
import { niewyslane, oznaczWyslane, oznaczOdrzucone, dopiszZSerwera, ustawienie, wszystkie, plik, plikiNiewyslane, oznaczPlikWyslany, maPlik, zapiszPlikZSerwera } from './baza.js';
import { wyslijPliki, pobierzPliki } from './sync_pliki.js';
import { skrotyPlikow } from './model/pliki.js';
import { pobierzWszystko } from './sync_pobieranie.js';

const ADAPTERY = {
  lokalnie: { nazwa: 'tylko to urządzenie', async wyslij() { return { ok: false, powod: 'brak serwera' }; } },
};

let adapter = ADAPTERY.lokalnie;
const sluchacze = new Set();
export const naZmiane = (f) => (sluchacze.add(f), () => sluchacze.delete(f));
const ogloszenie = (s) => sluchacze.forEach((f) => f(s));

export function ustawAdapter(a) { adapter = a; }

// pobieranie zdarzeń innych urządzeń (adapter bez `pobierz`, np. 'lokalnie', pomija ten krok)
async function pobierz(stan) {
  if (!adapter.pobierz) return;
  try {
    const r = await pobierzWszystko(adapter, await ustawienie('kursor-sync'), { dopisz: dopiszZSerwera, zapiszKursor: (k) => ustawienie('kursor-sync', k) });
    if (r.powod) stan.powod = r.powod;
    if (r.nowe) { stan.pobrane = r.nowe; sluchaczePobrania.forEach((f) => f(r.nowe)); }
  } catch (e) { stan.powod = powodBledu(e); }
}
// zerwane połączenie: fetch rzuca TypeError („Failed to fetch”, w Safari „Load failed”); użytkownikowi mówimy po polsku, co dalej
const powodBledu = (e) => (e instanceof TypeError ? 'brak połączenia z serwerem, wyślę przy następnej próbie' : e.message);
// pliki po zdarzeniach: najpierw nasze na serwer (żeby inni mogli je pobrać), potem brakujące u nas
async function pliki(stan) {
  if (!adapter.wyslijPlik) return;
  try {
    const w = await wyslijPliki(adapter, { doWyslania: await plikiNiewyslane(), czytaj: async (h) => { const f = await plik(h); return f && { dane: f.dane || await f.blob.arrayBuffer(), typ: f.typ }; }, oznacz: oznaczPlikWyslany });
    if (w.powod) stan.powod = w.powod; if (w.zostalo) stan.plikowDoWyslania = w.zostalo;
    const p = await pobierzPliki(adapter, { potrzebne: skrotyPlikow(await wszystkie()), mam: maPlik, zapisz: zapiszPlikZSerwera });
    if (p.powod) stan.powod = p.powod;
    if (p.uszkodzone.length) stan.powod = `plik na serwerze nie zgadza się ze skrótem (${p.uszkodzone.length}), nie zapisałem go`;
    if (p.pobrane) { stan.plikowPobrane = p.pobrane; sluchaczePobrania.forEach((f) => f(p.pobrane, 'pliki')); }
  } catch (e) { stan.powod = powodBledu(e); }
}
const sluchaczePobrania = new Set();
export const naPobranie = (f) => (sluchaczePobrania.add(f), () => sluchaczePobrania.delete(f));

// jedna synchronizacja naraz: zapis, powrót do aplikacji i zegar mogą ją wywołać w tej samej chwili; kolejne wywołanie dołącza do biegnącej
// i zamawia jeszcze jeden przebieg, żeby nic zapisanego w trakcie nie czekało do następnego zegara
let biezaca = null, jeszczeRaz = false;
export function synchronizuj() {
  if (biezaca) { jeszczeRaz = true; return biezaca; }
  biezaca = (async () => { let s; do { jeszczeRaz = false; s = await przebieg(); } while (jeszczeRaz); return s; })().finally(() => { biezaca = null; });
  return biezaca;
}

async function przebieg() {
  const doWyslania = await niewyslane();
  const stan = { niewyslane: doWyslania.length, online: navigator.onLine, adapter: adapter.nazwa };
  if (!navigator.onLine) return ogloszenie(stan), stan;
  if (!doWyslania.length) { await pobierz(stan); await pliki(stan); return ogloszenie(stan), stan; }
  try {
    // każda przyjęta paczka od razu oznaczona: po zerwaniu połączenia następna próba zaczyna od reszty, nie od początku
    const r = await adapter.wyslij(doWyslania, { poPaczce: (ids) => oznaczWyslane(ids) });
    if (r.ok) {
      const odrz = new Set(r.odrzucone || []);
      await oznaczWyslane(doWyslania.filter((z) => !odrz.has(z.id)).map((z) => z.id), r.czasSerwera);
      if (odrz.size) { await oznaczOdrzucone([...odrz]); stan.odrzucone = odrz.size; }
      stan.niewyslane = 0;
    } else { stan.powod = r.powod; stan.niewyslane = (await niewyslane()).length; }
  } catch (e) { stan.powod = powodBledu(e); stan.niewyslane = (await niewyslane()).length; }
  await pobierz(stan);
  await pliki(stan);
  ogloszenie(stan);
  return stan;
}

export function uruchomCykl() {
  synchronizuj();
  addEventListener('online', synchronizuj);
  addEventListener('offline', synchronizuj);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') synchronizuj(); });
  setInterval(() => { if (document.visibilityState === 'visible') synchronizuj(); }, 120000);
}
